import { useRef, useState } from 'react';
import { API_BASE } from '../config';

export default function AssignmentExcelImport({ onAssigned }) {
  const inputRef = useRef(null);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const upload = async () => {
    if (!file) {
      alert('배정 엑셀 파일을 선택해주세요.');
      return;
    }

    const ok = window.confirm(
      '선택한 엑셀 파일의 내용대로 앱을 일괄 배정합니다.\n계속하시겠습니까?'
    );
    if (!ok) return;

    setLoading(true);
    setResult(null);

    try {
      const formData = new FormData();
      formData.append('file', file);

      const res = await fetch(`${API_BASE}/api/admin/assignments/upload-excel`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: formData,
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok || !data.success) {
        setResult({
          success: false,
          message: data.error || '엑셀 배정 중 오류가 발생했습니다.',
          errors: Array.isArray(data.errors) ? data.errors : [],
        });
        return;
      }

      setResult({
        success: true,
        message: `배정 완료: 신규 ${data.inserted ?? 0}건 / 중복 ${data.duplicates ?? 0}건`,
        errors: [],
      });

      setFile(null);
      if (inputRef.current) inputRef.current.value = '';
      await onAssigned?.();
    } catch (err) {
      setResult({
        success: false,
        message: `네트워크 오류: ${err.message}`,
        errors: [],
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        marginTop: '16px',
        padding: '16px',
        border: '1px solid #d9d9d9',
        borderRadius: '8px',
        background: '#fafafa',
      }}
    >
      <div style={{ fontWeight: 700, marginBottom: '8px' }}>
        엑셀로 앱 일괄 배정
      </div>

      <div style={{ fontSize: '14px', color: '#555', lineHeight: 1.6, marginBottom: '10px' }}>
        엑셀 첫 행에 <b>출생년도, 성별, 성명, 배정 앱1, 배정 앱2</b> 형식으로 작성해주세요.
        <br />
        배정 앱3, 배정 앱4처럼 열을 추가해도 됩니다. 앱 이름은 사이트 관리에 등록된 이름과 같아야 합니다.
      </div>

      <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
        <input
          ref={inputRef}
          type="file"
          accept=".xlsx,.xls"
          onChange={(e) => {
            setFile(e.target.files?.[0] || null);
            setResult(null);
          }}
          disabled={loading}
        />

        <button
          type="button"
          className="user-input-button"
          onClick={upload}
          disabled={loading || !file}
        >
          {loading ? '등록 중...' : '엑셀 일괄 배정'}
        </button>
      </div>

      {file && (
        <div style={{ marginTop: '8px', fontSize: '13px', color: '#666' }}>
          선택 파일: {file.name}
        </div>
      )}

      {result && (
        <div
          style={{
            marginTop: '12px',
            padding: '10px',
            borderRadius: '6px',
            background: result.success ? '#eef8ee' : '#fff0f0',
            color: result.success ? '#226622' : '#a40000',
          }}
        >
          <div style={{ fontWeight: 700 }}>{result.message}</div>

          {result.errors?.length > 0 && (
            <div style={{ marginTop: '8px', maxHeight: '220px', overflowY: 'auto' }}>
              {result.errors.map((item, index) => (
                <div key={index} style={{ marginTop: '4px' }}>
                  {item.row ? `${item.row}행: ` : ''}{item.message || String(item)}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
